import React from "react";
import { Star, User } from "lucide-react";

const reviews = [
  {
    name: "Rahul S.",
    city: "Delhi",
    stars: 5,
    text: "Gained 4 kg in 6 weeks with a normal diet. Appetite improved a lot.",
    avatar: "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    name: "Aman K.",
    city: "Lucknow",
    stars: 5,
    text: "Stamina and strength both improved. Genuinely feels natural, no side effects.",
    avatar: "https://randomuser.me/api/portraits/men/45.jpg",
  },
  {
    name: "Vikas M.",
    city: "Pune",
    stars: 5,
    text: "Digestion is finally better and I actually feel hungry in the morning now.",
    avatar: "https://randomuser.me/api/portraits/men/54.jpg",
  },
  {
    name: "Suraj P.",
    city: "Bhopal",
    stars: 4,
    text: "Solid quality. The free diet plan alongside made a real difference.",
    avatar: "https://randomuser.me/api/portraits/men/22.jpg",
  },
];

const lifestyle = [
  "https://images.pexels.com/photos/1552242/pexels-photo-1552242.jpeg?auto=compress&cs=tinysrgb&w=800",
  "https://images.pexels.com/photos/1552103/pexels-photo-1552103.jpeg?auto=compress&cs=tinysrgb&w=800",
  "https://images.pexels.com/photos/1229356/pexels-photo-1229356.jpeg?auto=compress&cs=tinysrgb&w=800",
  "https://images.pexels.com/photos/2261477/pexels-photo-2261477.jpeg?auto=compress&cs=tinysrgb&w=800",
];

const AVATAR_FALLBACK =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40'>
       <rect width='40' height='40' fill='#1a0d02'/>
       <circle cx='20' cy='16' r='6' fill='#FF7A00'/>
       <path d='M6 36c2-8 10-12 14-12s12 4 14 12' fill='#FF7A00'/>
     </svg>`
  );

export default function Reviews() {
  return (
    <section className="relative bg-gradient-to-b from-black via-[#0a0603] to-black px-5 py-16 sm:py-20">
      <div className="mx-auto max-w-6xl">
        <div className="mb-8 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-[#FF7A00]">Reviews</div>
            <h2 className="mt-2 font-display text-4xl text-white sm:text-5xl">
              Trusted By <span className="text-fire">1000+</span> Men
            </h2>
            <p className="mt-2 text-sm text-neutral-400">
              *Placeholder testimonials — replace with real customer photos and stories anytime.
            </p>
          </div>
          <div className="flex items-center gap-3 rounded-2xl border border-white/10 bg-white/5 px-4 py-3">
            <span className="font-display text-4xl text-[#FFC107]">4.9</span>
            <div className="flex flex-col leading-tight">
              <div className="flex text-[#FFC107]">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={14} fill="#FFC107" strokeWidth={0} />
                ))}
              </div>
              <span className="text-xs text-neutral-400">1000+ verified customers</span>
            </div>
          </div>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {reviews.map((r) => (
            <div key={r.name} className="glass flex flex-col rounded-2xl p-5">
              <div className="flex items-center gap-3">
                <img
                  src={r.avatar}
                  alt={r.name}
                  loading="lazy"
                  onError={(e) => { e.currentTarget.src = AVATAR_FALLBACK; }}
                  className="h-10 w-10 rounded-full border border-[#FF7A00]/40 object-cover"
                />
                <div>
                  <div className="text-sm font-semibold text-white">{r.name}</div>
                  <div className="text-[11px] text-neutral-500">{r.city}</div>
                </div>
                <User size={16} className="ml-auto text-neutral-600" aria-hidden="true" />
              </div>
              <div className="mt-3 flex text-[#FFC107]">
                {[...Array(r.stars)].map((_, i) => (
                  <Star key={i} size={13} fill="#FFC107" strokeWidth={0} />
                ))}
              </div>
              <p className="mt-2 text-sm leading-relaxed text-neutral-200">&ldquo;{r.text}&rdquo;</p>
            </div>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-4">
          {lifestyle.map((src, i) => (
            <div key={i} className="relative aspect-square overflow-hidden rounded-2xl border border-white/10">
              <img
                src={src}
                loading="lazy"
                alt="transformation"
                onError={(e) => { e.currentTarget.style.display = "none"; }}
                className="h-full w-full object-cover opacity-90"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
